import { SVGFC } from '@repo/toolkit/types'

const ResetIcon: SVGFC = ({ color = 'white', ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4243_109414)">
        <path
          d="M10.7754 19.1168C9.11986 18.8332 7.60473 17.9673 6.50909 16.6786C5.40131 15.3756 4.79125 13.7141 4.79125 12C4.79125 10.286 5.40131 8.62444 6.50909 7.32148C7.34405 6.33939 8.42275 5.60325 9.62143 5.18285L9.43472 5.51483C9.29198 5.76859 9.38163 6.09016 9.63497 6.23314C9.88363 6.37475 10.2086 6.28866 10.3521 6.03254L11.1434 4.62566C11.2858 4.38618 11.1992 4.05184 10.9585 3.91199L9.57492 3.0759C9.32591 2.92543 9.00233 3.00563 8.85214 3.25502C8.70196 3.50442 8.78201 3.82853 9.03098 3.97896L9.33864 4.16487C7.93879 4.64275 6.67886 5.49504 5.70738 6.63769C4.43761 8.13127 3.73828 10.0357 3.73828 12C3.73828 13.9644 4.43761 15.8688 5.70742 17.3624C6.96274 18.8389 8.69953 19.8312 10.5979 20.1564C10.8778 20.2065 11.1579 20.0141 11.2056 19.7255C11.2546 19.4384 11.062 19.1659 10.7754 19.1168Z"
          fill={color}
        />
        <path
          d="M18.2924 6.63749C17.0371 5.16097 15.3003 4.16872 13.402 3.84356C13.1153 3.79451 12.8432 3.98738 12.7942 4.27443C12.7452 4.56152 12.9378 4.83401 13.2244 4.88313C14.8799 5.16673 16.395 6.03263 17.4907 7.32132C18.5985 8.62428 19.2085 10.2858 19.2085 11.9999C19.2085 13.7139 18.5985 15.3755 17.4907 16.6784C16.6557 17.6605 15.577 18.3967 14.3783 18.8171L14.5651 18.4851C14.7078 18.2313 14.6181 17.9097 14.3648 17.7668C14.1115 17.6239 13.7904 17.7136 13.6477 17.9674L12.8564 19.3743C12.714 19.6137 12.8004 19.9481 13.0412 20.0879L14.4249 20.924C14.6698 21.0731 14.9966 20.9965 15.1477 20.7449C15.2979 20.4955 15.2178 20.1714 14.9688 20.021L14.6612 19.835C16.061 19.3572 17.321 18.5049 18.2924 17.3622C19.5622 15.8686 20.2615 13.9642 20.2615 11.9998C20.2615 10.0355 19.5622 8.13107 18.2924 6.63749Z"
          fill={color}
        />
        <path
          d="M11.9998 6.86719C10.2192 6.86719 8.77066 8.31812 8.77066 10.1016V10.5533C8.28645 10.788 7.95166 11.2851 7.95166 11.8591V15.1908C7.95166 15.9902 8.601 16.6406 9.39908 16.6406H14.6004C15.3986 16.6406 16.0479 15.9902 16.0479 15.1908V11.8591C16.0479 11.2851 15.7131 10.788 15.2289 10.5533V10.1016C15.2289 8.31812 13.7804 6.86719 11.9998 6.86719ZM11.9998 7.92188C13.1997 7.92188 14.1759 8.89968 14.1759 10.1016V10.4093H9.82366V10.1016C9.82366 8.89968 10.7998 7.92188 11.9998 7.92188ZM14.9949 15.1908C14.9949 15.4087 14.818 15.5859 14.6005 15.5859H9.39911C9.1816 15.5859 9.00466 15.4087 9.00466 15.1908V11.8591C9.00466 11.6412 9.1816 11.464 9.39911 11.464H14.6005C14.818 11.464 14.9949 11.6412 14.9949 11.8591V15.1908Z"
          fill={color}
        />
        <path
          d="M12.0001 12.6328C11.7094 12.6328 11.4736 12.8689 11.4736 13.1602V13.8898C11.4736 14.181 11.7094 14.4171 12.0001 14.4171C12.2909 14.4171 12.5266 14.181 12.5266 13.8898V13.1602C12.5266 12.8689 12.2909 12.6328 12.0001 12.6328Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_4243_109414">
          <rect width="18" height="18" fill={color} transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ResetIcon
